/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback } from 'react';
import {
  // Box,
  Card,
  // CardHeader,
  // Divider,
  Typography,
  // Table,
  // TableBody,
  // TableCell,
  // TableRow,
  // CardContent,
  // ListItem,
  // List,
  Link,
  CircularProgress,
  TablePagination,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Backdrop,
  Box,
  Table,
  TableHead,
  TextField,
  Button
} from '@mui/material';
// import { customerApi } from '../../../api/customerApi';
// import useMounted from '../../../hooks/useMounted';
import * as moment from 'moment';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { withStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import Scrollbar from '../Scrollbar';
import useMounted from '../../hooks/useMounted';
import { campaignApi } from '../../api/campaignApi';
import Label from '../Label';
import { alpha } from '@mui/material/styles';
import { grey, lightVeil, toneAlpha } from '../../theme/tones';

const sortOptions = [
  {
    label: 'Plus récent',
    value: 'created_at|desc'
  },
  {
    label: 'Plus ancien',
    value: 'created_at|asc'
  },
];

const CampaignLogs = (props) => {
  const { idCampaign, ...other } = props;
  const theme = useTheme();
  const mounted = useMounted();
  const [logs, setLogs] = useState([]);
  const [logsInfos, setLogsInfos] = useState({ categories: [], types: [], users: [] });
  // const [filteredLogs, setFilteredLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [numberLogs, setNumberLogs] = useState(0);
  const [limit, setLimit] = useState(25);
  // const [isSearching, setIsSearching] = useState(false);
  const [sort, setSort] = useState('created_at|desc');
  const [user, setUser] = useState('all');
  const [category, setCategory] = useState('all');
  const [type, setType] = useState('all');

  const usersOptions = logsInfos.users.map((userInfo) => ({ value: userInfo.userId, label: `${userInfo.firstname} ${userInfo.lastname}` }));
  usersOptions.unshift({
    value: 'all',
    label: 'Tous'
  });

  const categoriesOptions = logsInfos.categories.map((categoryInfo) => ({ value: categoryInfo.category, label: categoryInfo.category.charAt(0).toUpperCase() + categoryInfo.category.slice(1) }));
  categoriesOptions.unshift({
    value: 'all',
    label: 'Tous'
  });

  const typesOptions = logsInfos.types.map((typeInfo) => ({ value: typeInfo.type, label: typeInfo.type.charAt(0).toUpperCase() + typeInfo.type.slice(1) }));
  typesOptions.unshift({
    value: 'all',
    label: 'Tous'
  });

  const getLogs = useCallback(async () => {
    try {
      const data = await campaignApi.getCampaignLogs(idCampaign, sort, user, category, type,
        limit, page, localStorage.getItem('accessToken'));
      const dataInfos = await campaignApi.getCampaignLogsInfos(idCampaign, localStorage.getItem('accessToken'));
      if (mounted.current) {
        setLogs(data.logs);
        setLogsInfos(dataInfos);
        setNumberLogs(data.numberLogs.numberLogs);
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, idCampaign, sort, user, category, type, limit, page]);

  useEffect(() => {
    getLogs();
  }, [getLogs]);

  // pour afficher le loader uniquement dans le tableau
  const StyledPaper = withStyles({
    root: {
      position: 'relative'
    }
  })(Paper);
  const LimitedBackdrop = withStyles({
    root: {
      position: 'absolute',
      zIndex: 1
    }
  })(Backdrop);

  const handleCustomers = (async (sortChange, userChange, categoryChange, typeChange, limitChoice, pageChoice, displaySpinnerTable = false) => {
    try {
      // si le spinner de la page n'est pas actif (loading), on déclenche le spinner de la table des apprenants au chargement des données
      if (!isLoading && displaySpinnerTable) {
        setIsLoading(true);
      }
      // setIsSearching(true);
      const data = await campaignApi.getLogs(window.localStorage.getItem('accessToken'), idCampaign, sortChange, userChange, categoryChange, typeChange,
        limitChoice, pageChoice);
      setNumberLogs(data.numberLogs.numberLogs);
      setLogs(data.logs);
      // setOptionsSearch(data.customers);
      setIsLoading(false);
      // setIsSearching(false);
      // setLoadingAutocomplete(false);
    } catch (err) {
      console.error(err);
    }
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    handleCustomers(sort, user, category, type, limit, newPage, true);
  };
  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);// handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, parseInt(event.target.value, 10), 0, modeRelance, true, true);
    handleCustomers(sort, user, category, type, event.target.value, 0, true);
  };

  const handleSortChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setSort(value);
    } else {
      setSort(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(event.target.value, user, category, type, limit, 0, true);
  };
  const handleUserChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setUser(value);
    } else {
      setUser(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(sort, event.target.value, category, type, limit, 0, true);
  };

  const handleCategoryChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setCategory(value);
    } else {
      setCategory(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(sort, user, event.target.value, type, limit, 0, true);
  };

  const handleTypeChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setType(value);
    } else {
      setType(event.target.value);
      // window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(sort, user, category, event.target.value, limit, 0, true);
  };

  const reinitializeFilters = () => {
    // on met à jour le localstorage
    // window.localStorage.setItem('choiceTabProfession', JSON.stringify('all'));
    // window.localStorage.setItem('choiceRelance', JSON.stringify('all'));
    // window.localStorage.setItem('choiceCampaign', JSON.stringify('all'));
    // window.localStorage.setItem('choiceCallTrackRelance', JSON.stringify('all'));
    // window.localStorage.setItem('choiceNewCallTrack', JSON.stringify('all'));
    // window.localStorage.setItem('choiceCallTrack', JSON.stringify('all'));
    // window.localStorage.setItem('choiceAvancement', JSON.stringify('all'));
    // window.localStorage.setItem('choiceEndSession', JSON.stringify('all'));
    // window.localStorage.setItem('choiceSource', JSON.stringify('all'));
    // on réinitialise les filtres
    setSort('created_at|desc');
    setType('all');
    setCategory('all');
    setUser('all');
    // // on affiche les résultats réinitialisés
    handleCustomers('created_at|desc', 'all', 'all', 'all', limit, page, true);
  };

  return (
    <Card 
      {...other}
      sx={{
        borderRadius: '24px',
        boxShadow: (theme) => `0 4px 18px 0 ${alpha(theme.palette.common.black, 0.03)}`,
        border: '1px solid',
        borderColor: (theme) => alpha(theme.palette.divider, 0.8),
        overflow: 'hidden'
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            mb: 2.5
          }}
        >
          <Box sx={{ width: 180 }}>
            <TextField
              fullWidth
              key="sort"
              label="Trier par date"
              name="sort"
              onChange={handleSortChange}
              select
              SelectProps={{ native: true }}
              value={sort}
              variant="outlined"
              size="small"
              disabled={isLoading}
              InputProps={{ sx: { borderRadius: '12px' } }}
              InputLabelProps={{ shrink: true }}
            >
              {sortOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: 220 }}>
            <TextField
              fullWidth
              key="user"
              label="Utilisateur"
              name="user"
              onChange={handleUserChange}
              select
              SelectProps={{ native: true }}
              value={user}
              variant="outlined"
              size="small"
              disabled={isLoading}
              InputProps={{ sx: { borderRadius: '12px' } }}
              InputLabelProps={{ shrink: true }}
            >
              {usersOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: 180 }}>
            <TextField
              fullWidth
              key="category"
              label="Catégorie"
              name="category"
              onChange={handleCategoryChange}
              select
              SelectProps={{ native: true }}
              value={category}
              variant="outlined"
              size="small"
              disabled={isLoading}
              InputProps={{ sx: { borderRadius: '12px' } }}
              InputLabelProps={{ shrink: true }}
            >
              {categoriesOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: 180 }}>
            <TextField
              fullWidth
              key="type"
              label="Type"
              name="type"
              onChange={handleTypeChange}
              select
              SelectProps={{ native: true }}
              value={type}
              variant="outlined"
              size="small"
              disabled={isLoading}
              InputProps={{ sx: { borderRadius: '12px' } }}
              InputLabelProps={{ shrink: true }}
            >
              {typesOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
        </Box>
        <Button
          onClick={reinitializeFilters}
          color="primary"
          variant="outlined"
          sx={{
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            borderColor: (theme) => alpha(theme.palette.secondary.main, 0.5),
            '&:hover': {
              borderColor: 'primary.main',
              backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.04),
            }
          }}
        >
          Réinitialiser les filtres
        </Button>
      </Box>

      <StyledPaper>
        <Scrollbar>
          <Box sx={{ minWidth: 700 }}>
            <Table>
              <TableHead
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? grey(50) : lightVeil(0.02),
                  borderBottom: `2px solid ${theme.palette.divider}`
                }}
              >
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                      py: 2,
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Utilisateur
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                      py: 2,
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Catégorie
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                      py: 2,
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Type
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                      py: 2,
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.mode === 'light' ? grey(600) : grey(400),
                      py: 2,
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Date
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {logs.map((log) => (
                  <TableRow
                    hover
                    key={log.id}
                    sx={{
                      transition: 'background-color 0.2s ease',
                      '&:hover': {
                        backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.02) : lightVeil(0.02)
                      }
                    }}
                  >
                    <TableCell sx={{ py: 2, fontWeight: 600, color: theme.palette.text.primary, borderColor: 'divider' }}>
                      {log.userInfos.firstname} {log.userInfos.lastname}
                    </TableCell>
                    <TableCell sx={{ py: 2, borderColor: 'divider' }}>
                      {log.category === 'utilisateur' && (
                      <Label color="success">
                        {log.category}
                      </Label>
                      )}
                      {log.category === 'notification' && (
                      <Label color="error">
                        {log.category}
                      </Label>
                      )}
                      {log.category === 'apprenant' && (
                      <Label color="warning">
                        {log.category}
                      </Label>
                      )}
                      {log.category === 'campagne' && (
                      <Label color="secondary">
                        {log.category}
                      </Label>
                      )}
                      {log.category === 'session' && (
                      <Label color="primary">
                        {log.category}
                      </Label>
                      )}
                      {log.category === 'formation' && (
                      <Label color="info">
                        {log.category}
                      </Label>
                      )}
                    </TableCell>
                    <TableCell sx={{ py: 2, textTransform: 'capitalize', color: 'text.secondary', fontSize: '0.85rem', borderColor: 'divider' }}>
                      {log.type}
                    </TableCell>
                    <TableCell sx={{ py: 2, fontSize: '0.85rem', color: theme.palette.text.primary, borderColor: 'divider' }}>
                      <div dangerouslySetInnerHTML={{ __html: log.description }} />
                    </TableCell>
                    <TableCell sx={{ py: 2, fontSize: '0.85rem', color: 'text.secondary', fontFamily: 'monospace', borderColor: 'divider' }}>
                      {moment(log.created_at).format('DD/MM/YYYY HH:mm:ss')}
                    </TableCell>
                  </TableRow>
                ))}
                <LimitedBackdrop
                  sx={{ color: grey(0), zIndex: (t) => t.zIndex.drawer + 1 }}
                  open={isLoading}
                >
                  <CircularProgress color="inherit" />
                </LimitedBackdrop>
              </TableBody>
            </Table>
          </Box>
        </Scrollbar>
      </StyledPaper>
      <TablePagination
        component="div"
        count={numberLogs}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[15, 25, 50]}
        SelectProps={{
          disabled: isLoading
        }}
        backIconButtonProps={
          isLoading
            ? { disabled: isLoading } : undefined
        }
        nextIconButtonProps={
          isLoading
            ? { disabled: isLoading } : undefined
        }
      />
    </Card>
  );
};
CampaignLogs.propTypes = {
  idCampaign: PropTypes.number.isRequired
};

export default CampaignLogs;
